import React from 'react';
import ModalProvider from 'mui-modal-provider';
import createSharedContext from './shared-context';
import { SnackbarProvider } from './use-snackbar';
// Root component with context providers
const Root = ({ children }) => (<SnackbarProvider>
    <ModalProvider>{children}</ModalProvider>
  </SnackbarProvider>);
// Create shared context instance
export const useContext = createSharedContext(Root);
